import { FontType } from '@primitives/Typography/types';
import { ChipSizeVariant } from './types';

export const chipLabelSizeToFontSize: Record<ChipSizeVariant, FontType> = {
    small: 'p5',
    medium: 'p3',
    large: 'p2',
};
